import React, { useState, useMemo } from 'react';
import { Search, X, Check, Users } from 'lucide-react';

const TagPersonnel = ({ allUsers, selectedIds, onToggle, currentUser }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredUsers = useMemo(() => {
        return allUsers.filter(u =>
            u.id !== currentUser?.id &&
            (u.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
                (u.full_name && u.full_name.toLowerCase().includes(searchTerm.toLowerCase())))
        );
    }, [allUsers, searchTerm, currentUser]);

    const selectedUsers = useMemo(() => {
        return allUsers.filter(u => selectedIds.includes(u.id));
    }, [allUsers, selectedIds]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%' }}>
            <label style={{ fontSize: '0.75rem', fontWeight: 800, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Tag Personnel
            </label>

            {/* Selected Pills */}
            {selectedUsers.length > 0 && (
                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', padding: '10px', background: 'rgba(255,255,255,0.02)', borderRadius: '12px', border: '1px solid var(--glass-border)' }}>
                    {selectedUsers.map(user => (
                        <div
                            key={user.id}
                            className="animate-fade"
                            style={{
                                display: 'flex', alignItems: 'center', gap: '8px',
                                background: 'linear-gradient(135deg, var(--accent-primary), #818cf8)',
                                color: 'white',
                                padding: '4px 12px', fontSize: '0.75rem', fontWeight: 800,
                                borderRadius: '10px', boxShadow: '0 4px 12px rgba(99, 102, 241, 0.2)',
                                border: '1px solid rgba(255,255,255,0.1)'
                            }}
                        >
                            <div style={{ width: '20px', height: '20px', borderRadius: '6px', overflow: 'hidden', background: 'rgba(0,0,0,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {user.avatar_url ? <img src={user.avatar_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <Users size={12} />}
                            </div>
                            <span>{user.full_name || user.username}</span>
                            <X
                                size={14}
                                style={{ cursor: 'pointer', opacity: 0.7, transition: 'opacity 0.2s' }}
                                onClick={() => onToggle(user.id)}
                                onMouseEnter={e => e.currentTarget.style.opacity = 1}
                                onMouseLeave={e => e.currentTarget.style.opacity = 0.7}
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* Search Input */}
            <div style={{ position: 'relative' }}>
                <Search size={16} style={{ position: 'absolute', left: '1rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
                <input
                    type="text"
                    placeholder="Search colleagues to tag..."
                    className="cyber-input"
                    style={{ paddingLeft: '2.75rem', width: '100%', fontSize: '0.9rem' }}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            {/* Results Dropdown/List */}
            {searchTerm && (
                <div style={{
                    maxHeight: '200px', overflowY: 'auto',
                    background: 'rgba(10, 11, 15, 0.95)', border: '1px solid var(--glass-border)',
                    borderRadius: '16px', padding: '0.5rem', marginTop: '-0.5rem',
                    backdropFilter: 'blur(20px)', zIndex: 10
                }}>
                    {filteredUsers.length > 0 ? filteredUsers.map(user => (
                        <div
                            key={user.id}
                            onClick={() => { onToggle(user.id); setSearchTerm(''); }}
                            style={{
                                display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.6rem 1rem',
                                borderRadius: '10px', cursor: 'pointer', transition: 'all 0.2s ease',
                                background: selectedIds.includes(user.id) ? 'rgba(99, 102, 241, 0.1)' : 'transparent'
                            }}
                            className="hover-item"
                        >
                            <div style={{ width: '32px', height: '32px', borderRadius: '8px', overflow: 'hidden', background: 'var(--bg-deep)' }}>
                                {user.avatar_url ? <img src={user.avatar_url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.7rem' }}>{user.username[0].toUpperCase()}</div>}
                            </div>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '0.85rem', fontWeight: 800, color: 'var(--text-heading)' }}>{user.full_name || user.username}</div>
                                <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>@{user.username}</div>
                            </div>
                            {selectedIds.includes(user.id) && <Check size={16} color="var(--accent-primary)" />}
                        </div>
                    )) : (
                        <div style={{ padding: '1rem', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>No personnel found.</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TagPersonnel;
